

import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { registerUser } from "../utils/usersAPI";
import { RemoveProductFromCart, GetProductsInCartByUserId, ClearCart } from "../utils/productInCart";
import { useSelector, useDispatch } from 'react-redux';
import {
  Box,
  Card,
  CardContent,
  CardActions,
  Button,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import { ADD_ITEM, REMOVE_ITEM, SET_LOGGED_PRODUCTINCART, CLEAR_CART, UPDATE_ITEM_AMOUNT } from '../features/productInCartSlice';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { getProductById, getTotal } from '../helpers/productHelpers';
import EmptyCartMessage from './EmptyCartMessage';
import { backgrounds } from 'polished';
import ProductButtons from './ProductButtons';
import QuantityCounter from "./QuantityCounter"; // למעלה בקובץ העגלה
import { UpdateProduct } from "../utils/productInCart";
// import { ADD_ITEM } from "../features/productInCartSlice";
// import Swal from "sweetalert2";
import IconButton from "@mui/material/IconButton";
import CartItemActions from "./CartItemActions";
import {
  getUnitPrice,
  calculateItemTotal,
  calculateCartTotal,
} from "../helpers/cartPriceHelper";
import { getDealLabel } from "../helpers/dealHelpers";
import DealChip from "./DealChip";



const Cart = () => {

  // const dispatch = useDispatch();//בשביל עדכון הסטייט
  // const loggedUser = useSelector(state => state.user.logedUser);//בשביל שימוש מהסלייס - לזהות את המשתמש ונלקח מסלייס
  const navigate = useNavigate();
  const cart = useSelector(state => state.cart.items)    // בשביל לזהות אם המוצר קיים כבר בעגלה
  const products = useSelector(state => state.product.products);

  const COLOR_MAP = {
    "שחור": "#000000",
    "לבן": "#FFFFFF",
    "אדום": "#E53935",
    "כחול": "#1E88E5",
    "תכלת": "#4FC3F7",   // ← תכלת
    "ירוק": "#43A047",
    "צהוב": "#FDD835",
    "כתום": "#FB8C00",
    "ורוד": "#D81B60",
    "סגול": "#8E24AA",
    "חום": "#6D4C41",
    "אפור": "#757575",
    "זהב": "#C9A227",
    "כסף": "#B0BEC5",
  };


  // const removeFromCart = (productId) => {
  //   RemoveProductFromCart(productId).then(res => {
  //     const newCart = cart.filter((item) => item.productInCarts[0].id !== productId);
  //     setCart(newCart);
  //   });
  // };

  // 


  //פונקציה שתמחק את כל המוצרים בסל יחד:
  // const handelClearCart = () => {
  //   ClearCart(loggedUser.id).then(res => setCart([]))
  // };
  const handelClearCart = () => {
    Swal.fire({
      title: "בטוח למחוק את כל העגלה?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "כן, נקה את העגלה!"
    }).then((result) => {
      if (result.isConfirmed) {
        if (loggedUser) {
          ClearCart(loggedUser.id).then(res => {
            dispatch(CLEAR_CART());
          });
        } else {
          dispatch(CLEAR_CART());
        }

        Swal.fire({
          title: "בוצע בהצלחה",
          text: "העגלה שלך ריקה!",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });
      }
    });
  };

  const loggedUser = useSelector((state) => state.user.logedUser);
  const dispatch = useDispatch();



  const total = calculateCartTotal(cart);

  const API_BASE =
    process.env.REACT_APP_API_BASE_URL || "";

  const resolveImgSrc = (img) => {
    if (!img) return null;
    if (img instanceof File) return URL.createObjectURL(img);
    const path = String(img).replace(/\\/g, "/"); // ליתר ביטחון אם הגיעו backslashes
    if (path.startsWith("http") || path.startsWith("//")) return path;
    return `${API_BASE}${path}`; // הופך "/       /..." ל־"https://localhost:7010/uploads/..."
  };

  const handleCheckoutClick = () => {
    if (loggedUser) {
      navigate("/CheckoutSummary");
    } else {
      navigate("/signIn", { state: { from: "/CheckoutSummary" } });
    }
  };

  return (
    <Card sx={{
      maxWidth: 830,   // רוחב מקסימלי
      width: "100%",   // שלא יתחרבש במסכים קטנים
      mx: "auto",      // margin-inline: auto -> מרכז אותו אופקית
    }}>
      <CardContent>
        <Typography color="textSecondary" gutterBottom sx={{
          fontSize: "24px",   // גודל הטקסט
          fontWeight: 700,    // טיפונת מודגש
          color: "#D81B60",   // ורוד
        }}>
          סל קניות:
        </Typography>
        {cart.map((item) => {

          const product = item.product;
          const displayImage = item.productOption?.image || product?.image;

          const unitPrice = getUnitPrice(item);
          const lineTotal = calculateItemTotal(item);
          const dealLabel = getDealLabel(product);


          return (
            <React.Fragment key={item.id}>
              <ListItem>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "80px minmax(0, 1fr) 170px 150px 80px",
                    alignItems: "center",
                    columnGap: 2,
                    width: "100%",
                    direction: "rtl",
                  }}
                >

                  {/* תמונת המוצר */}
                  <Box
                    component="img"
                    src={resolveImgSrc(displayImage)}
                    alt={product?.name}
                    sx={{
                      width: 70,
                      height: 70,
                      objectFit: "cover",
                      borderRadius: 1,
                      border: "1px solid #eee",
                    }}
                  />

                  <Box sx={{ flexGrow: 1 }}>
                    <Box
                      sx={{
                        width: "100%",          // ← להוסיף
                        display: "flex",        // ← במקום inline-flex
                        flexDirection: "column",
                        alignItems: "flex-end",
                      }}
                    >
                      <DealChip product={item.product} />

                      <Typography
                        sx={{
                          width: "100%",
                          fontWeight: 600,
                          fontSize: "18px",
                          lineHeight: 1.3,
                          mt: 0.5,
                          textAlign: "right",
                          whiteSpace: "normal",
                          wordBreak: "break-word",
                          overflowWrap: "break-word",
                        }}
                      >
                        {item.product?.name}
                      </Typography>
                    </Box>
                    {/* וריאציה – שורה מתחת */}
                    {item.productOption && (
                      <Typography
                        sx={{
                          fontWeight: 500,
                          textAlign: "right",
                          fontSize: "18px",
                          marginTop: "2px",
                        }}
                      >
                        {item.productOption.optionType === "Color" ? "צבע" : "בחירה"}:{" "}

                        {item.productOption.optionType === "Color" ? (
                          <Box
                            component="span"
                            sx={{
                              fontWeight: 700,
                              px: 0.75,
                              borderRadius: 0.75,
                              ...(item.productOption.value === "לבן"
                                ? {
                                  color: "#111",          // טקסט שחור כדי שייראה
                                  backgroundColor: "#fff", // תגית לבנה
                                  border: "1px solid #ccc",
                                }
                                : {
                                  color: COLOR_MAP[item.productOption.value] || "inherit",
                                }),
                            }}
                          >
                            {item.productOption.value}
                          </Box>
                        ) : (
                          <Box component="span" sx={{ fontWeight: 700 }}>
                            {item.productOption.value}
                          </Box>
                        )}

                      </Typography>
                    )}

                  </Box>



                  {/* כמות × מחיר ליחידה */}
                  <Typography sx={{ minWidth: 140, textAlign: "center", fontWeight: 600, fontSize: '18px', whiteSpace: 'nowrap' }}>
                    כמות: {item.amount} × {unitPrice.toFixed(2)} ₪
                  </Typography>

                  {/* סה"כ למוצר */}
                  <Typography
                    sx={{
                      minWidth: 140,
                      textAlign: "center",
                      fontWeight: 600,
                      fontSize: '18px',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    סה"כ: {lineTotal.toFixed(2)} ₪
                  </Typography>

                  {/* כמות מוצר */}




                  <CartItemActions item={item} product={product} variant="cart" />
                </Box>
              </ListItem>
              <Divider />
            </React.Fragment>
          );
        })}

        {/* <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "80px 1fr 160px 160px auto auto",
            width: "100%",
            mt: 3,
          }}
        >
          <Box
            sx={{
              gridColumn: 4/5, // עמודה 4 = כמו "סה\"כ: ... ₪" של כל מוצר
              justifyContent: "center",
              fontWeight: 600,
              fontSize: "20px",
              whiteSpace: "nowrap",
            }}
          >
         סה"כ לתשלום: ₪{total.toFixed(2)}
          </Box>
        </Box> */}
        <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, justifyContent: 'flex-end', gap: 25, pr: 29 }}>
          <Typography sx={{
            fontSize: '20px',
            fontWeight: 600,
            ml: 16,
          }}>
            סה"כ לתשלום: ₪{total.toFixed(2)}
          </Typography>
        </Box>
      </CardContent>
      <CardActions>
        <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex', justifyContent: 'end' }, gap: 2 }}>

          {cart.length ? (<>
            {/* <Button variant="contained" onClick={handelClearCart} sx={{ backgroundColor: "#D81B60" }}>נקה את סל הקניות</Button> */}
            <Button variant="contained" onClick={handleCheckoutClick} sx={{ backgroundColor: "#D81B60" }}>המשך לקופה  </Button>
            <Button variant="contained" onClick={() => navigate('/products')} sx={{ backgroundColor: "#D81B60" }}>המשך בקנייה</Button></>) :
            <Button variant="contained" onClick={() => navigate('/products')} sx={{ backgroundColor: "#D81B60" }}>התחל בקניה</Button>}
        </Box>
      </CardActions>
    </Card>

  );
};

export default Cart;


